import React, { useState, useEffect } from "react";
import "./rightsidebar.css";
import Navbar from "../../components/navbar/Navbar";
import { HugeiconsIcon } from "@hugeicons/react";
import {
  Add01Icon,
  Calendar02Icon,
  FireIcon,
  ZapIcon,
  Coffee02Icon,
  GridViewIcon,
  LeftToRightListBulletIcon,
  Search01Icon,
  MoreHorizontalIcon,
  Download04FreeIcons,
} from "@hugeicons/core-free-icons";
import Priority from "../../components/priority/Priority";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import RepairSelector from "../../components/repairs/Repairs";
import PartSelector from "../../components/repairs/Parts";
import ProgressFilter from "../../components/progressfilter/ProgressFilter";
import Pagination from "react-bootstrap/Pagination";
import Order from "../order/Order";
import { useAlternators } from "../../context/AlternatorContext";
import { useAuth } from "../../context/AuthContext";
import Cables from "../cables/Cables";
import TimeCard from "../timecard/TimeCard";
import ChangeUsersPassword from "../ChangeUsersPassword/changeUsersPassword";
import Hose from "../hose/Hose";
import Messages from "../messages/Messages";
import Notification from "../notification/Notification";
import Member from "../member/Member";
import Email from "../email/Email";
import MyProject from "../myProject/MyProject";
import Overview from "../overview/Overview";
import Price from "../pricing/Price";
import OldPrice from "../pricing/OldPrice";
import AdminPricing from "../pricing/AdminPricing";

const getPriorityStyles = (priority) => {
  switch (priority) {
    case "High":
      return { color: "red", bgColor: "#FFF2F2", icon: FireIcon };
    case "Medium":
      return { color: "orange", bgColor: "lightyellow", icon: ZapIcon };
    case "Low":
      return { color: "green", bgColor: "#EAFAEA", icon: Coffee02Icon };
    default:
      return { color: "black", bgColor: "white" };
  }
};

const RightSideBar = ({ selected }) => {
  const {
    alternatorPaginationData,
    alternators,
    loading,
    error,
    fetchAlternators,
    addAlternator,
    updateAlternator,
    deleteAlternator,
    exportAlternators,
    fetchAlternatorCounts,
    alternatorCounts,
  } = useAlternators();

  const [currentPage, setCurrentPage] = useState(
    alternatorPaginationData.current_page || 1
  );
  const itemsPerPage = alternatorPaginationData.per_page || 12;
  const [selectedStatus, setSelectedStatus] = useState("All");
  const statuses = [
    "All",
    "New",
    "Awaiting Parts",
    "In Progress",
    "Awaiting Pickup",
    //"Picked Up",
    "Completed",
    "Returns",
  ];

  const [sortBy, setSortBy] = useState("created_at");
  const [sortDirection, setSortDirection] = useState("desc");
  const [viewMode, setViewMode] = useState("table");
  const [repairs, setRepairs] = useState([]);
  const [parts, setParts] = useState([]);
  const { token } = useAuth();
  const [showAddModal, setShowAddModal] = useState(false);
  const [showInfoModal, setShowInfoModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const user = JSON.parse(localStorage.getItem("user"));
  const [showDownloadModal, setShowDownloadModal] = useState(false);

  const handleCloseAddModal = () => {
    setShowAddModal(false);
    resetFormData();
  };
  const handleShowAddModal = () => setShowAddModal(true);

  const handleCloseInfoModal = () => {
    setShowInfoModal(false);
    setSelectedItem({});
  };
  const handleShowInfoModal = () => setShowInfoModal(true);

  const handleCloseEditModal = () => {
    setShowEditModal(false);
    resetFormData();
    setSelectedItem({});
  };
  const handleShowEditModal = () => setShowEditModal(true);

  const [formData, setFormData] = useState({
    customerName: "",
    phoneNumber: "",
    email: "",
    plateNumber: "",
    dateIn: "",
    dateOut: "",
    progress: "New",
    priority: "Low",
    comments: "",
    partsNeeded: [],
    repairNeeded: [],
  });

  const [selectedItem, setSelectedItem] = useState({});

  const resetFormData = () => {
    setFormData({
      customerName: "",
      phoneNumber: "",
      email: "",
      plateNumber: "",
      dateIn: "",
      dateOut: "",
      progress: "New",
      priority: "Low",
      comments: "",
      partsNeeded: [],
      repairNeeded: [],
    });
    setRepairs([]);
    setParts([]);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleAddSubmit = async () => {
    const finalData = {
      ...formData,
      phoneNumber: formData.phoneNumber,
      email: formData.email,
      plateNumber: formData.plateNumber,
      repairNeeded: repairs,
      partsNeeded: parts,
    };
    const success = await addAlternator(finalData);
    if (success) {
      handleCloseAddModal();
      fetchAlternatorCounts();
    }
  };

  const handleEditSubmit = async () => {
    if (!selectedItem.id) return;
    const finalData = {
      ...formData,
      phoneNumber: formData.phoneNumber,
      email: formData.email,
      plateNumber: formData.plateNumber,
      repairNeeded: repairs,
      partsNeeded: parts,
    };
    const success = await updateAlternator(selectedItem.id, finalData);
    if (success) {
      handleCloseEditModal();
      fetchAlternatorCounts();
    }
  };

  const handleDelete = async (id) => {
    const success = await deleteAlternator(id);
    if (success) {
      handleCloseInfoModal();
      fetchAlternatorCounts();
    }
  };

  const handleEditClick = (item) => {
    setSelectedItem(item);
    setFormData({
      customerName: item.customerName || "",
      phoneNumber: item.phoneNumber || "",
      email: item.email || "",
      plateNumber: item.plateNumber || "",
      dateIn: item.dateIn || "",
      dateOut: item.dateOut || "",
      poNumber: item.poNumber || "",
      progress: item.progress || "New",
      comments: item.comments || "",
      priority: item.priority || "Low",
      partsNeeded: item.partsNeeded || [],
      repairNeeded: item.repairNeeded || [],
    });
    setRepairs(item.repairNeeded || []);
    setParts(item.partsNeeded || []);
    handleShowEditModal();
  };

  const countByStatus = (status) => {
    return alternatorCounts[status] || 0;
  };

  const displayedAlternators = alternators;
  const totalPages = alternatorPaginationData.last_page || 1;

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleSortClick = (column) => {
    if (sortBy === column) {
      setSortDirection(sortDirection === "asc" ? "desc" : "asc");
    } else {
      setSortBy(column);
      setSortDirection("asc");
    }
    setCurrentPage(1);
  };

  useEffect(() => {
    const params = {
      page: currentPage,
      per_page: itemsPerPage,
      ...(selectedStatus !== "All" && { progress: selectedStatus }),
      sortBy: sortBy,
      sortDirection: sortDirection,
      ...(startDate && { startDate: startDate }),
      ...(endDate && { endDate: endDate }),
      ...(searchTerm && { search: searchTerm }),
    };
    fetchAlternators(params);
  }, [
    currentPage,
    selectedStatus,
    sortBy,
    sortDirection,
    itemsPerPage,
    startDate,
    endDate,
    searchTerm,
  ]);

  useEffect(() => {
    fetchAlternatorCounts();
  }, [startDate, endDate, searchTerm]);

  useEffect(() => {
    if (
      alternatorPaginationData.current_page &&
      alternatorPaginationData.current_page !== currentPage
    ) {
      setCurrentPage(alternatorPaginationData.current_page);
    }
  }, [alternatorPaginationData.current_page]);

  const handleDateFilterChange = (e) => {
    const { name, value } = e.target;
    if (name === "startDate") {
      setStartDate(value);
    } else if (name === "endDate") {
      setEndDate(value);
    }
    setCurrentPage(1);
  };

  const clearDateFilters = () => {
    setStartDate("");
    setEndDate("");
    setCurrentPage(1);
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1);
  };

  const handleDownload = async (type) => {
    console.log(`Downloading alternators as ${type}`);
    const params = {
      sortBy: sortBy,
      sortDirection: sortDirection,
      ...(searchTerm && { search: searchTerm }),
    };
    await exportAlternators(type, params);
    setShowDownloadModal(false);
  };

  return (
    <div className="rightsidebar">
      <div className="rightsidebar-container">
        <Navbar />
        {selected === "Overview" && (
          <div className="rightsidebar-bottom">
            <Overview />
          </div>
        )}
        {selected === "Dashboard" && (
          <div className="rightsidebar-bottom">
            <div className="rightsidebar-navbar">
              <h3>Madison Generator – Alternators</h3>
              <div className="button-group d-flex flex-row">
                {" "}
                <div
                  className="rightsidebar-button"
                  onClick={handleShowAddModal}
                >
                  <HugeiconsIcon
                    icon={Add01Icon}
                    size={16}
                    color="#ffffff"
                    strokeWidth={3}
                  />
                  <p>New Alternator</p>
                </div>
                <div
                  className="rightsidebar-button"
                  style={{ backgroundColor: "#3c58ae", marginLeft: "10px" }}
                  onClick={() => setShowDownloadModal(true)}
                >
                  <HugeiconsIcon
                    icon={Download04FreeIcons}
                    size={16}
                    color="#ffffff"
                    strokeWidth={2}
                  />
                  <p>Download</p>
                </div>
              </div>
            </div>
            <div className="rightsidebar-filter">
              <div className="rightsidebar-filter-button">
                <div
                  className={`custom-filter-button ${
                    viewMode === "table" ? "active" : ""
                  }`}
                  onClick={() => setViewMode("table")}
                >
                  <HugeiconsIcon
                    icon={LeftToRightListBulletIcon}
                    size={14}
                    color="#545454"
                  />
                  <p>List</p>
                </div>
                <div
                  className={`custom-filter-button ${
                    viewMode === "grid" ? "active" : ""
                  }`}
                  onClick={() => setViewMode("grid")}
                >
                  <HugeiconsIcon
                    icon={GridViewIcon}
                    size={14}
                    color="#545454"
                  />
                  <p>Grid</p>
                </div>
              </div>

              <div className="search-input-container">
                <HugeiconsIcon icon={Search01Icon} size={16} color="#545454" />
                <input
                  type="text"
                  placeholder="Search alternators..."
                  value={searchTerm}
                  onChange={handleSearchChange}
                  className="search-input"
                />
              </div>

              <div className="rightsidebar-filter-date">
                <div className="date-range-picker">
                  <label htmlFor="startDate">Start Date:</label>
                  <input
                    type="date"
                    id="startDate"
                    name="startDate"
                    value={startDate}
                    onChange={handleDateFilterChange}
                    className="date-input custom-filter-button filter-date"
                  />
                </div>
                <div className="date-range-picker mx-2">
                  <label htmlFor="endDate">End Date:</label>
                  <input
                    type="date"
                    id="endDate"
                    name="endDate"
                    value={endDate}
                    onChange={handleDateFilterChange}
                    className="date-input custom-filter-button filter-date"
                  />
                </div>

                {(startDate || endDate) && (
                  <button
                    className="clear-date-button"
                    onClick={clearDateFilters}
                  >
                    Clear Dates
                  </button>
                )}
              </div>
            </div>

            <div className="custom-line no-margin"></div>

            <div className="rightsidebar-filter-progress">
              {statuses.map((status) => (
                <div
                  key={status}
                  onClick={() => setSelectedStatus(status)}
                  style={{ cursor: "pointer" }}
                >
                  <ProgressFilter
                    title={status}
                    count={countByStatus(status)}
                    bgColor={selectedStatus === status ? "#333" : "#f1f1f1"}
                    color={selectedStatus === status ? "#fff" : "#000"}
                  />
                </div>
              ))}
            </div>

            <div className="rightsidebar-table">
              {loading ? (
                <p>Loading alternators...</p>
              ) : error ? (
                <p>Error: {error.message}</p>
              ) : viewMode === "table" ? (
                <div className="order-table-container">
                  <div className="rightsidebar-table">
                    <table className="custom-table">
                      <thead>
                        <tr>
                          <th
                            onClick={() => handleSortClick("id")}
                            style={{ cursor: "pointer" }}
                          >
                            s/n{" "}
                            {sortBy === "id" &&
                              (sortDirection === "asc" ? "▲" : "▼")}
                          </th>
                          <th
                            onClick={() => handleSortClick("customerName")}
                            style={{ cursor: "pointer" }}
                          >
                            Customer Name{" "}
                            {sortBy === "customerName" &&
                              (sortDirection === "asc" ? "▲" : "▼")}
                          </th>
                          <th
                            onClick={() => handleSortClick("phoneNumber")}
                            style={{ cursor: "pointer" }}
                          >
                            Phone Number{" "}
                            {sortBy === "phoneNumber" &&
                              (sortDirection === "asc" ? "▲" : "▼")}
                          </th>
                          <th
                            onClick={() => handleSortClick("email")}
                            style={{ cursor: "pointer" }}
                          >
                            Email{" "}
                            {sortBy === "email" &&
                              (sortDirection === "asc" ? "▲" : "▼")}
                          </th>
                          <th
                            onClick={() => handleSortClick("plateNumber")}
                            style={{ cursor: "pointer" }}
                          >
                            Plate Number{" "}
                            {sortBy === "plateNumber" &&
                              (sortDirection === "asc" ? "▲" : "▼")}
                          </th>
                          <th
                            onClick={() => handleSortClick("dateIn")}
                            style={{ cursor: "pointer" }}
                          >
                            Date-In{" "}
                            {sortBy === "dateIn" &&
                              (sortDirection === "asc" ? "▲" : "▼")}
                          </th>
                          <th
                            onClick={() => handleSortClick("dateOut")}
                            style={{ cursor: "pointer" }}
                          >
                            Date-Out{" "}
                            {sortBy === "dateOut" &&
                              (sortDirection === "asc" ? "▲" : "▼")}
                          </th>
                          <th
                            onClick={() => handleSortClick("dateOut")}
                            style={{ cursor: "pointer" }}
                          >
                            Due-Date{" "}
                            {sortBy === "dateOut" &&
                              (sortDirection === "asc" ? "▲" : "▼")}
                          </th>
                          <th
                            onClick={() => handleSortClick("progress")}
                            style={{ cursor: "pointer" }}
                          >
                            Progress{" "}
                            {sortBy === "progress" &&
                              (sortDirection === "asc" ? "▲" : "▼")}
                          </th>
                          <th>Repair Needed</th>
                          <th>Parts Needed</th>
                          <th
                            onClick={() => handleSortClick("dateOut")}
                            style={{ cursor: "pointer" }}
                          >
                            Days-to-go{" "}
                            {sortBy === "dateOut" &&
                              (sortDirection === "asc" ? "▲" : "▼")}
                          </th>
                          <th>PO Number </th>
                          <th
                            onClick={() => handleSortClick("priority")}
                            style={{ cursor: "pointer" }}
                          >
                            Priority{" "}
                            {sortBy === "priority" &&
                              (sortDirection === "asc" ? "▲" : "▼")}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {Array.isArray(displayedAlternators) &&
                        displayedAlternators.length === 0 ? (
                          <tr>
                            <td colSpan="10">No data available</td>
                          </tr>
                        ) : (
                          Array.isArray(displayedAlternators) &&
                          displayedAlternators.map((item) => {
                            const { color, bgColor, icon } = getPriorityStyles(
                              item.priority
                            );
                            return (
                              <tr
                                key={item.id}
                                onClick={() => {
                                  setSelectedItem(item);
                                  handleShowInfoModal();
                                }}
                              >
                                <td>{item.id}</td>
                                <td>{item.customerName}</td>
                                <td>{item.phoneNumber}</td>
                                <td>
                                  {item?.email
                                    ? item?.email.length > 10
                                      ? `${item.email.slice(0, 10)}...`
                                      : item?.email
                                    : ""}
                                </td>
                                <td>
                                  {item.plateNumber
                                    ? item.plateNumber.length > 8
                                      ? `${item.plateNumber.slice(0, 8)}...`
                                      : item.plateNumber
                                    : ""}
                                </td>
                                <td>
                                  {item.dateIn
                                    ? new Date(item.dateIn)
                                        .toISOString()
                                        .substring(0, 10)
                                    : "N/A"}
                                </td>
                                <td>
                                  {item.dateOut
                                    ? new Date(item.dateOut)
                                        .toISOString()
                                        .substring(0, 10)
                                    : "N/A"}
                                </td>
                                <td>
                                  {item.dateOut
                                    ? new Date(item.dateOut)
                                        .toISOString()
                                        .substring(0, 10)
                                    : "N/A"}
                                </td>
                                <td>{item.progress}</td>
                                <td>
                                  {Array.isArray(item.repairNeeded)
                                    ? (() => {
                                        const joined =
                                          item.repairNeeded.join(", ");
                                        return joined.length > 20
                                          ? `${joined.slice(0, 12)}...`
                                          : joined;
                                      })()
                                    : item.repairNeeded}
                                </td>
                                <td>
                                  {Array.isArray(item.partsNeeded)
                                    ? (() => {
                                        const fullText = item.partsNeeded
                                          .map(
                                            (part) =>
                                              `${part.name} (${part.quantity})`
                                          )
                                          .join(", ");

                                        const maxLength = 35;

                                        return fullText.length > maxLength
                                          ? `${fullText.slice(0, maxLength)}...`
                                          : fullText;
                                      })()
                                    : item.partsNeeded}
                                </td>
                                <td>
                                  {" "}
                                  {item.dateOut == null ? (
                                    <DaysToGo
                                      dateIn={item.dateIn}
                                      dueDate={item.dueDate}
                                    />
                                  ) : (
                                    ""
                                  )}
                                </td>
                                <td>{item.poNumber}</td>
                                <td>
                                  <Priority
                                    color={color}
                                    bgColor={bgColor}
                                    icon={icon}
                                    title={item.priority}
                                  />
                                </td>
                              </tr>
                            );
                          })
                        )}
                      </tbody>
                    </table>
                    <div className="custom-grid-pagination table">
                      <Pagination>
                        <Pagination.First
                          onClick={() => handlePageChange(1)}
                          disabled={currentPage === 1}
                        />
                        <Pagination.Prev
                          onClick={() => handlePageChange(currentPage - 1)}
                          disabled={currentPage === 1}
                        />
                        {[...Array(totalPages)].map((_, index) => (
                          <Pagination.Item
                            key={index + 1}
                            active={index + 1 === currentPage}
                            onClick={() => handlePageChange(index + 1)}
                          >
                            {index + 1}
                          </Pagination.Item>
                        ))}
                        <Pagination.Next
                          onClick={() => handlePageChange(currentPage + 1)}
                          disabled={currentPage === totalPages}
                        />
                        <Pagination.Last
                          onClick={() => handlePageChange(totalPages)}
                          disabled={currentPage === totalPages}
                        />
                      </Pagination>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="order-table-container">
                  <div className="gridview-container">
                    {Array.isArray(displayedAlternators) &&
                    displayedAlternators.length === 0 ? (
                      <div className="no-data-message">
                        <p>No data available.</p>
                      </div>
                    ) : (
                      <>
                        <div className="grid-view">
                          {Array.isArray(displayedAlternators) &&
                            displayedAlternators.map((item) => {
                              const { color, bgColor, icon } =
                                getPriorityStyles(item.priority);
                              return (
                                <div
                                  key={item.id}
                                  className="custom-grid"
                                  onClick={() => {
                                    setSelectedItem(item);
                                    handleShowInfoModal();
                                  }}
                                >
                                  <div className="custom-grid-top-container">
                                    <Priority
                                      color={color}
                                      bgColor={bgColor}
                                      icon={icon}
                                      title={item.priority}
                                    />
                                    <div className="custom-grid-edit">
                                      <HugeiconsIcon
                                        icon={MoreHorizontalIcon}
                                        size={20}
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          handleEditClick(item);
                                        }}
                                      />
                                    </div>
                                  </div>
                                  <div className="custom-grid-bottom-container">
                                    <h3>{item.customerName}</h3>
                                    <p>Phone: {item.phoneNumber}</p>
                                    <p>Email: {item.email}</p>
                                    <p>Plate: {item.plateNumber}</p>
                                    <div className="custom-line"></div>
                                    <div className="custom-grid-bottom-date">
                                      <p>
                                        {item.dateIn
                                          ? new Date(
                                              item.dateIn
                                            ).toLocaleDateString("en-GB", {
                                              day: "2-digit",
                                              month: "short",
                                              year: "2-digit",
                                            })
                                          : "N/A"}
                                      </p>
                                      <p>{item.progress}</p>
                                    </div>
                                  </div>
                                </div>
                              );
                            })}
                        </div>
                        <div className="custom-grid-pagination">
                          <Pagination>
                            <Pagination.First
                              onClick={() => handlePageChange(1)}
                              disabled={currentPage === 1}
                            />
                            <Pagination.Prev
                              onClick={() => handlePageChange(currentPage - 1)}
                              disabled={currentPage === 1}
                            />
                            {[...Array(totalPages)].map((_, index) => (
                              <Pagination.Item
                                key={index + 1}
                                active={index + 1 === currentPage}
                                onClick={() => handlePageChange(index + 1)}
                              >
                                {index + 1}
                              </Pagination.Item>
                            ))}
                            <Pagination.Next
                              onClick={() => handlePageChange(currentPage + 1)}
                              disabled={currentPage === totalPages}
                            />
                            <Pagination.Last
                              onClick={() => handlePageChange(totalPages)}
                              disabled={currentPage === totalPages}
                            />
                          </Pagination>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        )}

        {selected === "Order" && (
          <div className="rightsidebar-bottom">
            <Order />
          </div>
        )}
        {selected === "OldPrice" && (
          <div className="rightsidebar-bottom">
            <OldPrice />
          </div>
        )}
        {selected === "Price" && (
          <div className="rightsidebar-bottom">
            <Price />
          </div>
        )}
        {selected === "AdminPricing" && user?.name === "admin" && (
          <div className="rightsidebar-bottom">
            <AdminPricing />
          </div>
        )}
        {selected === "Member" && (
          <div className="rightsidebar-bottom">
            <Member />
          </div>
        )}
        {selected === "Messages" && (
          <div className="rightsidebar-bottom">
            <Messages />
          </div>
        )}
        {selected === "Email" && (
          <div className="rightsidebar-bottom">
            <Email />
          </div>
        )}

        {selected === "Notification" && (
          <div className="rightsidebar-bottom">
            <Notification />
          </div>
        )}
        {selected === "MyProject" && (
          <div className="rightsidebar-bottom">
            <MyProject />
          </div>
        )}
        {selected === "Hose" && (
          <div className="rightsidebar-bottom">
            <Hose selected={selected} />
          </div>
        )}
        {selected === "Cables" && (
          <div className="rightsidebar-bottom">
            <Cables selected={selected} />
          </div>
        )}
        {selected === "TimeCard" && (
          <div className="rightsidebar-bottom">
            <TimeCard />
          </div>
        )}
        {selected === "ChangePassword" && user?.name === "admin" && (
          <div className="rightsidebar-bottom">
            <ChangeUsersPassword />
          </div>
        )}
      </div>

      <Modal
        show={showAddModal}
        onHide={handleCloseAddModal}
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <h3>New Alternator</h3>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form className="custom-form">
            <div className="form-group">
              <label htmlFor="customerName">Customer Name</label>
              <input
                type="text"
                id="customerName"
                name="customerName"
                className="input-field"
                value={formData.customerName}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label htmlFor="phoneNumber">Phone Number</label>
              <input
                type="text"
                id="phoneNumber"
                name="phoneNumber"
                className="input-field"
                value={formData.phoneNumber}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input
                type="text"
                id="email"
                name="email"
                className="input-field"
                value={formData.email}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label htmlFor="plateNumber">Plate Number</label>
              <input
                type="text"
                id="plateNumber"
                name="plateNumber"
                className="input-field"
                value={formData.plateNumber}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label htmlFor="dateIn">Date In</label>
              <input
                type="date"
                id="dateIn"
                name="dateIn"
                className="input-field"
                value={formData.dateIn}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label htmlFor="dateOut">Date Out</label>
              <input
                type="date"
                id="dateOut"
                name="dateOut"
                className="input-field"
                value={formData.dateOut}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label htmlFor="dateIn">Due Date</label>
              <input
                type="date"
                id="dueDate"
                name="dueDate"
                className="input-field"
                value={formData.dueDate}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label htmlFor="poNumber">PO Number</label>
              <input
                id="poNumber"
                name="poNumber"
                className="input-field"
                value={formData.poNumber}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label htmlFor="progress">Status</label>
              <select
                id="progress"
                name="progress"
                className="input-field"
                value={formData.progress}
                onChange={handleChange}
              >
                {statuses.slice(1).map((status) => (
                  <option key={status} value={status}>
                    {status}
                  </option>
                ))}
              </select>
            </div>
            <div className="form-group">
              <RepairSelector
                selectedRepairs={repairs}
                setSelectedRepairs={setRepairs}
              />
            </div>
            <div className="form-group">
              <PartSelector selectedParts={parts} setSelectedParts={setParts} />
            </div>
            <div className="form-group">
              <label htmlFor="priority">Priority</label>
              <select
                id="priority"
                name="priority"
                className="input-field"
                value={formData.priority}
                onChange={handleChange}
              >
                <option>Low</option>
                <option>Medium</option>
                <option>High</option>
              </select>
            </div>
            <div className="form-group">
              <label htmlFor="comments">Comments</label>
              <textarea
                id="comments"
                name="comments"
                className="input-field textarea"
                value={formData.comments}
                onChange={handleChange}
              />
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer>
          <div className="flex gap-2 d-flex">
            <button className="btn-secondary" onClick={handleCloseAddModal}>
              Cancel
            </button>
            <button className="btn-primary" onClick={handleAddSubmit}>
              Save
            </button>
          </div>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showInfoModal}
        onHide={handleCloseInfoModal}
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <h3>Alternator Details</h3>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedItem && (
            <>
              <div className="info-group">
                <strong>Customer Name:</strong>
                <p>{selectedItem.customerName}</p>
              </div>
              <div className="info-group">
                <strong>Phone Number:</strong>
                <p>{selectedItem.phoneNumber}</p>
              </div>
              <div className="info-group">
                <strong>Email:</strong>
                <p>{selectedItem.email}</p>
              </div>
              <div className="info-group">
                <strong>Plate Number:</strong>
                <p>{selectedItem.plateNumber}</p>
              </div>
              <div className="info-group">
                <strong>Date In:</strong>
                <p>
                  {selectedItem.dateIn
                    ? new Date(selectedItem.dateIn)
                        .toISOString()
                        .substring(0, 10)
                    : "N/A"}
                </p>
              </div>
              <div className="info-group">
                <strong>Date Out:</strong>
                <p>
                  {selectedItem.dateOut
                    ? new Date(selectedItem.dateOut)
                        .toISOString()
                        .substring(0, 10)
                    : "N/A"}
                </p>
              </div>
              <div className="info-group">
                <strong>Due Date:</strong>
                <p>
                  {selectedItem.dueDate
                    ? new Date(selectedItem.dueDate)
                        .toISOString()
                        .substring(0, 10)
                    : "N/A"}
                </p>
              </div>
              <div className="info-group">
                <strong>PO Number:</strong>
                <p>{selectedItem.poNumber}</p>
              </div>
              <div className="info-group">
                <strong>Status:</strong>
                <p>{selectedItem.progress}</p>
              </div>
              <div className="info-group">
                <strong>Repairs Needed:</strong>
                <p>
                  {Array.isArray(selectedItem.repairNeeded)
                    ? selectedItem.repairNeeded.join(", ")
                    : selectedItem.repairNeeded}
                </p>
              </div>
              <div className="info-group">
                <strong>Parts Needed:</strong>
                <p>
                  {Array.isArray(selectedItem.partsNeeded)
                    ? selectedItem.partsNeeded
                        .map((part) => `${part.name} (${part.quantity})`)
                        .join(", ")
                    : selectedItem.partsNeeded}
                </p>
              </div>
              <div className="info-group">
                <strong>Priority:</strong>
                <p>{selectedItem.priority}</p>
              </div>
              {selectedItem.comments && (
                <div className="info-group">
                  <strong>Comments:</strong>
                  <p>{selectedItem.comments}</p>
                </div>
              )}

              {selectedItem.author && (
                <div className="info-group">
                  <strong>Created By:</strong>
                  <p>{selectedItem.author.name}</p>
                </div>
              )}

              {selectedItem.history && selectedItem.history.length > 0 && (
                <div className="info-group">
                  <strong>Alternator History:</strong>
                  <ul>
                    {selectedItem.history.map((historyEntry) => (
                      <li key={historyEntry.id}>
                        {historyEntry.changes &&
                        typeof historyEntry.changes === "string" ? (
                          JSON.parse(historyEntry.changes).map(
                            (change, index) => <p key={index}>{change}</p>
                          )
                        ) : (
                          <p>{historyEntry.changes}</p>
                        )}
                        <small>
                          by{" "}
                          {historyEntry.user
                            ? historyEntry.user.name
                            : "Unknown User"}{" "}
                          on{" "}
                          {new Date(historyEntry.created_at).toLocaleString()}
                        </small>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <div className="flex gap-2 d-flex">
            <button className="btn-secondary" onClick={handleCloseInfoModal}>
              Cancel
            </button>
            {user.name === "admin" && (
              <button
                className="btn-danger"
                onClick={() => handleDelete(selectedItem.id)}
              >
                Delete
              </button>
            )}
            <button
              className="btn-primary"
              onClick={() => {
                handleCloseInfoModal();
                handleEditClick(selectedItem);
              }}
            >
              Edit
            </button>
          </div>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showEditModal}
        onHide={handleCloseEditModal}
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <h3>Edit Alternator</h3>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form className="custom-form">
            <div className="form-group">
              <label htmlFor="editCustomerName">Customer Name</label>
              <input
                type="text"
                id="editCustomerName"
                name="customerName"
                className="input-field"
                value={formData.customerName}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label htmlFor="editPhoneNumber">Phone Number</label>
              <input
                type="text"
                id="editPhoneNumber"
                name="phoneNumber"
                className="input-field"
                value={formData.phoneNumber}
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <label htmlFor="editEmail">Email</label>
              <input
                type="text"
                id="editEmail"
                name="email"
                className="input-field"
                value={formData.email}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label htmlFor="editPlateNumber">Plate Number</label>
              <input
                type="text"
                id="editPlateNumber"
                name="plateNumber"
                className="input-field"
                value={formData.plateNumber}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label htmlFor="editDateIn">Date In</label>
              <input
                type="date"
                id="editDateIn"
                name="dateIn"
                className="input-field"
                value={formData.dateIn}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label htmlFor="editDateOut">Date Out</label>
              <input
                type="date"
                id="editDateOut"
                name="dateOut"
                className="input-field"
                value={formData.dateOut}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label htmlFor="editDateOut">Due Date</label>
              <input
                type="date"
                id="editDueDate"
                name="dueDate"
                className="input-field"
                value={formData.dueDate}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label htmlFor="editPONumber">PO Number</label>
              <input
                id="editPONumber"
                name="poNumber"
                className="input-field"
                value={formData.poNumber}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label htmlFor="editProgress">Status</label>
              <select
                id="editProgress"
                name="progress"
                className="input-field"
                value={formData.progress}
                onChange={handleChange}
              >
                {statuses.slice(1).map((status) => (
                  <option key={status} value={status}>
                    {status}
                  </option>
                ))}
              </select>
            </div>
            <div className="form-group">
              <RepairSelector
                selectedRepairs={repairs}
                setSelectedRepairs={setRepairs}
              />
              <p className="pb-2">Selected Repairs:</p>
              <div className="selected-repairs-list">
                {Array.isArray(repairs) && repairs.length > 0 ? (
                  repairs.map((repair, index) => (
                    <div key={index} className="selected-repair-item">
                      <span>{repair}</span>
                      <button
                        type="button"
                        className="remove-repair-button"
                        onClick={() => {
                          const updatedRepairs = repairs.filter(
                            (_, i) => i !== index
                          );
                          setRepairs(updatedRepairs);
                        }}
                      >
                        ×
                      </button>
                    </div>
                  ))
                ) : (
                  <p>No repairs selected</p>
                )}
              </div>
            </div>
            <div className="form-group">
              <PartSelector selectedParts={parts} setSelectedParts={setParts} />
              <div className="selected-parts-list">
                {Array.isArray(parts) && parts.length > 0 ? (
                  parts.map((part, index) => (
                    <div key={index} className="selected-part-item">
                      <span>
                        {part.name} (Qty: {part.quantity})
                      </span>
                      <button
                        type="button"
                        className="remove-part-button"
                        onClick={() => {
                          const updatedParts = [...parts];
                          updatedParts.splice(index, 1);
                          setParts(updatedParts);
                        }}
                      >
                        ×
                      </button>
                    </div>
                  ))
                ) : (
                  <p>No parts selected</p>
                )}
              </div>
            </div>
            <div className="form-group">
              <label htmlFor="editPriority">Priority</label>
              <select
                id="editPriority"
                name="priority"
                className="input-field"
                value={formData.priority}
                onChange={handleChange}
              >
                <option>Low</option>
                <option>Medium</option>
                <option>High</option>
              </select>
            </div>
            <div className="form-group">
              <label htmlFor="editComments">Comments</label>
              <textarea
                id="editComments"
                name="comments"
                className="input-field textarea"
                value={formData.comments}
                onChange={handleChange}
              />
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer>
          <div className="flex gap-2 d-flex">
            <button className="btn-secondary" onClick={handleCloseEditModal}>
              Cancel
            </button>
            <button className="btn-primary" onClick={handleEditSubmit}>
              Save Changes
            </button>
          </div>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showDownloadModal}
        onHide={() => setShowDownloadModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Download Alternator Data</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>How would you like to download the alternator data?</p>
          <div className="modal-button-download">
            <Button
              className="download-button"
              variant="outline-primary"
              onClick={() => handleDownload("pdf")}
            >
              PDF
            </Button>
            <Button
              variant="outline-success"
              onClick={() => handleDownload("csv")}
            >
              CSV
            </Button>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowDownloadModal(false)}
          >
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

const calculateDaysToGo = (dueDateString) => {
  if (!dueDateString) {
    return "N/A";
  }

  const dueDate = new Date(dueDateString);
  const today = new Date();

  const one_day = 1000 * 60 * 60 * 24;
  const utcToday = Date.UTC(
    today.getFullYear(),
    today.getMonth(),
    today.getDate()
  );
  const utcDueDate = Date.UTC(
    dueDate.getFullYear(),
    dueDate.getMonth(),
    dueDate.getDate()
  );

  const diffInMilliseconds = utcDueDate - utcToday;

  const daysToGo = Math.floor(diffInMilliseconds / one_day);

  if (isNaN(daysToGo)) {
    return "N/A";
  }

  return daysToGo;
};

const DaysToGo = ({ dateIn, dueDate }) => {
  const days = calculateDaysToGo(dueDate);

  let displayText;
  let bgColor = "transparent";
  let textColor = "inherit";

  if (days === "N/A") {
    displayText = "N/A";
  } else if (days < 0) {
    displayText = `OVERDUE by ${Math.abs(days)} days`;
    bgColor = "#FFE5E5";
    textColor = "red";
  } else if (days === 0) {
    displayText = "DUE TODAY";
    bgColor = "#FFE5E5";
    textColor = "red";
  } else if (days <= 7) {
    displayText = `${days} days`;
    bgColor = "#FFE5E5";
    textColor = "red";
  } else {
    displayText = `${days} days`;
  }

  return (
    <div
      style={{
        backgroundColor: bgColor,
        color: textColor,
        fontWeight: "bold",
        textAlign: "center",
        borderRadius: "4px",
        padding: "4px 6px",
      }}
    >
      {displayText}
    </div>
  );
};

export default RightSideBar;
